import React, { Component } from 'react';
import LogoNordeste from '../imagens/logo nordeste pequeno.jpg';

export default class extends Component {
    state = {  }
    render() {
        return (
            <div>
                {/* <h2>Página Sobre</h2> */}
                <img 
                    className="home-menu-logo"
                    alt="Expresso Nordeste" 
                    src={LogoNordeste} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/SobrePage.js